module.exports = __webpack_public_path__ + "img/logo-for-video-blur.aebc378.svg";